import React from 'react';
import { useSelector } from 'react-redux';

import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs = () => {
  const breadcrumbs = useSelector((state) => state.getIn(['entity', 'breadcrumbs']));

  return (
    <ol className="Breadcrumbs" itemScope itemType="https://schema.org/BreadcrumbList">
      {breadcrumbs.map((item, index) => {
        const url = item.get('url');
        const title = item.get('title');
        return (
          <li
            key={url}
            className="icon-after icon-chevron icon-variant-5"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ItemList"
          >
            <CoreLink itemProp="item" to={url}>{title.replace(/<[^>]*>?/gm, '')}</CoreLink>
            <meta itemProp="position" content={index} />
          </li>
        );
      })}
    </ol>
  );
};

export default Breadcrumbs;
